import React, { Component, PropTypes } from 'react';
import lodash from 'lodash';
import { Button, Modal, Col, Row } from 'react-bootstrap';
import {
  nations,
  competitions,
  individualCategories,
  pasdedeuxCategories,
  squadCategories,
  genders,
} from '../../constants/values';
import formValidation from '../../utils/formValidation';
import { onInputChange } from '../../utils/helpers';
import { Input, DatePicker } from '../inputs';
import AutoComplete from './AutoComplete';

const nationsWithoutAdmin = nations.filter(n => n.value !== 'ADMIN');
const containerStyle = isHighlighted => ({
  background: isHighlighted ? 'lightgray' : 'white',
  padding: '3px 0 3px 10px',
});

export default class CreateEntry extends Component {
  static propTypes = {
    isPushingData: PropTypes.bool.isRequired,
    onSubmitForm: PropTypes.func.isRequired,
    fetchAthleteByFeiId: PropTypes.func.isRequired,
    nation: PropTypes.string.isRequired,
    competition: PropTypes.string.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    athlete: PropTypes.object.isRequired,
    allVaulters: PropTypes.array.isRequired,
    lungers: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    const { nation, competition } = this.props;

    this.initialEntryData = {
      nation: nation && nation !== 'ADMIN' ? nation : '',
      competition: competition || '',
      details: {},
    };

    this.state = {
      formErrors: [],
      showCreateEntryModal: false,
      entryData: lodash.cloneDeep(this.initialEntryData),
      vaulters: [{}],
      vaultersValues: [''],
      vaulterId: '',
      horseId: '',
      lungerId: '',
      vaulterValue: '',
      lungerValue: '',
      secondVaulter: '',
      horseValue: '',
    };

    this.onInputChange = onInputChange().bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { competition: nextCompetition, nation: nextNation } = nextProps;
    const { competition, nation } = this.props;
    const { entryData } = this.state;

    if (nextNation !== nation || nextCompetition !== competition) {
      this.initialEntryData = {
        nation: nextNation && nextNation !== 'ADMIN' ? nextNation : '',
        competition: nextCompetition || '',
        details: {},
      };

      this.setState({
        entryData: {
          ...entryData,
          ...{ nation: nextNation, competition: nextCompetition },
        },
      });
    }
  }

  onGetAthleteByFeiId(refName, type) {
    const { fetchAthleteByFeiId } = this.props;

    const feiId = this.refs[refName].getValue();

    fetchAthleteByFeiId(feiId, type).then(() => {
      this.fillInputs(refName, feiId);
    });
  }

  fillInputs(refName, feiId) {
    const { entryData, vaulters } = this.state;
    const { athlete } = this.props;

    const a = athlete[feiId];

    if (refName === 'vaulterFeiId') {
      entryData.details = {
        ...entryData.details,
        ...{
          vaulterFeiId: a.feiId,
          vaulterFirstName: a.firstName,
          vaulterLastName: a.lastName,
          vaulterGender: a.gender,
          vaulterDateOfBirth: a.dateOfBirth,
        },
      };
    } else if (refName === 'firstVaulterFeiId') {
      entryData.details = {
        ...entryData.details,
        ...{
          firstVaulterFeiId: a.feiId,
          firstVaulterFirstName: a.firstName,
          firstVaulterLastName: a.lastName,
          firstVaulterGender: a.gender,
          firstVaulterDateOfBirth: a.dateOfBirth,
        },
      };
    } else if (refName === 'secondVaulterFeiId') {
      entryData.details = {
        ...entryData.details,
        ...{
          secondVaulterFeiId: a.feiId,
          secondVaulterFirstName: a.firstName,
          secondVaulterLastName: a.lastName,
          secondVaulterGender: a.gender,
          secondVaulterDateOfBirth: a.dateOfBirth,
        },
      };
    } else if (refName === 'lungerFeiId') {
      entryData.details = {
        ...entryData.details,
        ...{
          lungerFeiId: a.feiId,
          lungerFirstName: a.firstName,
          lungerLastName: a.lastName,
        },
      };
    } else if (refName === 'horseFeiId') {
      entryData.details = {
        ...entryData.details,
        ...{
          horseFeiId: a.feiId,
          horseName: a.name,
        },
      };
    } else {
      const refNameArr = refName.split('.');

      if (refNameArr[0] === 'vaulters') {
        vaulters[refNameArr[1]] = {
          vaulterFeiId: a.feiId,
          vaulterFirstName: a.firstName,
          vaulterLastName: a.lastName,
          vaulterGender: a.gender,
          vaulterDateOfBirth: a.dateOfBirth,
        };
      }
    }

    this.setState({
      entryData,
      vaulters,
    });
  }

  addSquadVaulter = () => {
    this.setState({
      vaulters: [...this.state.vaulters, {}],
      vaultersValues: [...this.state.vaultersValues, ''],
    });
  };

  removeSquadVaulter = idx => {
    const { vaulters, vaultersValues } = this.state;

    this.setState({
      vaulters: [...vaulters.slice(0, idx), ...vaulters.slice(idx + 1)],
      vaultersValues: [...vaultersValues.slice(0, idx), ...vaultersValues.slice(idx + 1)],
    });
  };

  openCreateEntryModal = () => {
    this.props.loadEntities();
    this.setState({
      formErrors: [],
      showCreateEntryModal: true,
    });
  };

  closeCreateEntryModal = () => {
    this.setState({
      formErrors: [],
      showCreateEntryModal: false,
      entryData: lodash.cloneDeep(this.initialEntryData),
      vaulters: [{}],
      vaultersValues: [''],
      vaulterId: '',
      horseId: '',
      lungerId: '',
      vaulterValue: '',
      lungerValue: '',
      horseValue: '',
      secondVaulter: '',
    });
  };

  handleSubmitForm = () => {
    const { onSubmitForm, submitEntitiesData } = this.props;
    const { entryData, vaulters, lungerId, vaulterId, horseId } = this.state;

    const data = { entryData };

    if (entryData.competition === 'INDIVIDUALS') {
      data.individualsDetails = entryData.details;
    } else if (entryData.competition === 'PASDEDEUX') {
      data.pasDeDeuxDetails = entryData.details;
    } else if (entryData.competition === 'SQUAD') {
      entryData.details.vaulters = vaulters;
      data.squadDetails = entryData.details;
    }

    formValidation(data).then(formErrors => {
      this.setState({ formErrors });

      if (!!formErrors.length) {
        return;
      }

      if (entryData.competition === 'INDIVIDUALS') {
        submitEntitiesData(entryData, vaulterId, lungerId, horseId);
      }

      onSubmitForm(entryData)
        .then(() => {
          this.closeCreateEntryModal();
        })
        .catch(() => {
          this.closeCreateEntryModal();
        });
    });
  };

  renderLoadFeiId(refName, type) {
    return (
      <Button
        type="button"
        onClick={this.onGetAthleteByFeiId.bind(this, refName, type)}
        tabIndex="-1"
        style={{ marginTop: 0 }}
      >
        <i className="fa fa-refresh" />
      </Button>
    );
  }

  onVaulterSelect = vaulterValue => {
    const { entryData } = this.state;
    const { allVaulters } = this.props;
    const vaulter = allVaulters.filter(
      vaulter => `${vaulter.vaulterFirstName} ${vaulter.vaulterLastName}` === vaulterValue
    )[0];
    const vaulterId = vaulter._id;

    entryData.details = {
      ...entryData.details,
      ...{
        vaulterFeiId: vaulter.vaulterFeiId,
        vaulterFirstName: vaulter.vaulterFirstName,
        vaulterLastName: vaulter.vaulterLastName,
        vaulterGender: vaulter.vaulterGender,
        vaulterDateOfBirth: vaulter.vaulterDateOfBirth,
      },
    };

    this.setState({
      vaulterId,
      vaulterValue,
      entryData,
    });
  };

  onLungerSelect = lungerValue => {
    const { entryData } = this.state;
    const { lungers } = this.props;
    const lunger = lungers.filter(
      lunger => `${lunger.lungerFirstName} ${lunger.lungerLastName}` === lungerValue
    )[0];
    const lungerId = lunger._id;

    entryData.details = {
      ...entryData.details,
      ...{
        lungerFeiId: lunger.lungerFeiId,
        lungerFirstName: lunger.lungerFirstName,
        lungerLastName: lunger.lungerLastName,
      },
    };

    this.setState({
      lungerId,
      lungerValue,
      entryData,
    });
  };

  onHorseSelect = horseValue => {
    const { entryData } = this.state;
    const { horses } = this.props;
    const horse = horses.filter(horse => horse.horseName === horseValue)[0];
    const horseId = horse._id;

    entryData.details = {
      ...entryData.details,
      ...{
        horseFeiId: horse.horseFeiId,
        horseName: horse.horseName,
      },
    };

    this.setState({
      horseId,
      horseValue,
      entryData,
    });
  };

  renderIndividualsInputs() {
    const { formErrors, entryData, vaulterValue } = this.state;
    const { allVaulters } = this.props;

    return (
      <div style={{ paddingTop: 20, paddingBottom: 20 }}>
        <AutoComplete
          label="Choose a vaulter"
          data={allVaulters}
          value={vaulterValue}
          renderItem={(item, isHighlighted) => (
            <div key={item._id} style={containerStyle(isHighlighted)}>
              {`${item.vaulterFirstName} ${item.vaulterLastName}`}
            </div>
          )}
          getItemValue={item => `${item.vaulterFirstName} ${item.vaulterLastName}`}
          onChange={(event, vaulterValue) => this.setState({ vaulterValue })}
          onSelect={this.onVaulterSelect}
          shouldItemRender={item =>
            `${item.vaulterFirstName} ${item.vaulterLastName}`
              .toLowerCase()
              .includes(vaulterValue.toLowerCase())
          }
        />

        <Row>
          <Col xs={4}>
            <Input
              type="text"
              onChange={this.onInputChange('entryData.details.vaulterFeiId')}
              value={entryData.details.vaulterFeiId}
              errors={formErrors}
              name="vaulterFeiId"
              label="Vaulter FEI ID"
              buttonAfter={this.renderLoadFeiId('vaulterFeiId', 'person')}
              ref="vaulterFeiId"
              refInput="vaulterFeiId"
            />
          </Col>

          <Col xs={4}>
            <Input
              type="text"
              onChange={this.onInputChange('entryData.details.vaulterFirstName')}
              value={entryData.details.vaulterFirstName}
              errors={formErrors}
              name="vaulterFirstName"
              label="Vaulter First Name"
            />
          </Col>

          <Col xs={4}>
            <Input
              type="text"
              onChange={this.onInputChange('entryData.details.vaulterLastName')}
              value={entryData.details.vaulterLastName}
              errors={formErrors}
              name="vaulterLastName"
              label="Vaulter Last Name"
            />
          </Col>
        </Row>

        <Row>
          <Col xs={4}>
            <Input
              type="select"
              onChange={this.onInputChange('entryData.details.vaulterGender')}
              value={entryData.details.vaulterGender}
              defaultValue=""
              errors={formErrors}
              name="vaulterGender"
              label="Vaulter Gender"
            >
              <option disabled value="" />
              {genders.map(gender => (
                <option key={gender.value} value={gender.value}>
                  {gender.name}
                </option>
              ))}
            </Input>
          </Col>

          <Col xs={4}>
            <DatePicker
              onChange={this.onInputChange('entryData.details.vaulterDateOfBirth')}
              value={entryData.details.vaulterDateOfBirth}
              errors={formErrors}
              name="vaulterDateOfBirth"
              label="Vaulter Date of Birth"
            />
          </Col>
        </Row>
      </div>
    );
  }

  onPasDeDeuxSelect = idx => vaulterValue => {
    const { entryData } = this.state;
    const { allVaulters } = this.props;
    const vaulter = allVaulters.filter(
      vaulter => `${vaulter.vaulterFirstName} ${vaulter.vaulterLastName}` === vaulterValue
    )[0];

    if (idx === 1) {
      entryData.details = {
        ...entryData.details,
        ...{
          firstVaulterFeiId: vaulter.vaulterFeiId,
          firstVaulterFirstName: vaulter.vaulterFirstName,
          firstVaulterLastName: vaulter.vaulterLastName,
          firstVaulterGender: vaulter.vaulterGender,
          firstVaulterDateOfBirth: vaulter.vaulterDateOfBirth,
        },
      };
      this.setState({ entryData, vaulterValue });
    }

    if (idx === 2) {
      let secondVaulter = vaulterValue;

      entryData.details = {
        ...entryData.details,
        ...{
          secondVaulterFeiId: vaulter.vaulterFeiId,
          secondVaulterFirstName: vaulter.vaulterFirstName,
          secondVaulterLastName: vaulter.vaulterLastName,
          secondVaulterGender: vaulter.vaulterGender,
          secondVaulterDateOfBirth: vaulter.vaulterDateOfBirth,
        },
      };
      this.setState({ entryData, secondVaulter });
    }
  };

  renderPasDeDeuxInputs() {
    const { formErrors, entryData, vaulterValue, secondVaulter } = this.state;
    const { allVaulters } = this.props;

    return (
      <div style={{ paddingTop: 20, paddingBottom: 20 }}>
        <AutoComplete
          label="Choose 1st vaulter"
          data={allVaulters}
          value={vaulterValue}
          renderItem={(item, isHighlighted) => (
            <div key={item._id} style={containerStyle(isHighlighted)}>
              {`${item.vaulterFirstName} ${item.vaulterLastName}`}
            </div>
          )}
          getItemValue={item => `${item.vaulterFirstName} ${item.vaulterLastName}`}
          onChange={(event, vaulterValue) => this.setState({ vaulterValue })}
          onSelect={this.onPasDeDeuxSelect(1)}
          shouldItemRender={item =>
            `${item.vaulterFirstName} ${item.vaulterLastName}`
              .toLowerCase()
              .includes(vaulterValue.toLowerCase())
          }
        />
        <Row>
          <Col xs={4}>
            <Input
              type="text"
              onChange={this.onInputChange('entryData.details.firstVaulterFeiId')}
              value={entryData.details.firstVaulterFeiId}
              errors={formErrors}
              name="firstVaulterFeiId"
              label="1st Vaulter FEI ID"
              buttonAfter={this.renderLoadFeiId('firstVaulterFeiId', 'person')}
              ref="firstVaulterFeiId"
              refInput="firstVaulterFeiId"
            />
          </Col>

          <Col xs={4}>
            <Input
              type="text"
              onChange={this.onInputChange('entryData.details.firstVaulterFirstName')}
              value={entryData.details.firstVaulterFirstName}
              errors={formErrors}
              name="firstVaulterFirstName"
              label="1st Vaulter First Name"
            />
          </Col>

          <Col xs={4}>
            <Input
              type="text"
              onChange={this.onInputChange('entryData.details.firstVaulterLastName')}
              value={entryData.details.firstVaulterLastName}
              errors={formErrors}
              name="firstVaulterLastName"
              label="1st Vaulter Last Name"
            />
          </Col>
        </Row>

        <Row>
          <Col xs={4}>
            <Input
              type="select"
              onChange={this.onInputChange('entryData.details.firstVaulterGender')}
              value={entryData.details.firstVaulterGender}
              defaultValue=""
              errors={formErrors}
              name="firstVaulterGender"
              label="1st Vaulter Gender"
            >
              <option disabled value="" />
              {genders.map(gender => (
                <option key={gender.value} value={gender.value}>
                  {gender.name}
                </option>
              ))}
            </Input>
          </Col>

          <Col xs={4}>
            <DatePicker
              onChange={this.onInputChange('entryData.details.firstVaulterDateOfBirth')}
              value={entryData.details.firstVaulterDateOfBirth}
              errors={formErrors}
              name="firstVaulterDateOfBirth"
              label="1st Vaulter Date of Birth"
            />
          </Col>
        </Row>

        <div style={{ paddingTop: 10 }}>
          <AutoComplete
            label="Choose 2nd vaulter"
            data={allVaulters}
            value={secondVaulter}
            renderItem={(item, isHighlighted) => (
              <div key={item._id} style={containerStyle(isHighlighted)}>
                {`${item.vaulterFirstName} ${item.vaulterLastName}`}
              </div>
            )}
            getItemValue={item => `${item.vaulterFirstName} ${item.vaulterLastName}`}
            onChange={(event, secondVaulter) => this.setState({ secondVaulter })}
            onSelect={this.onPasDeDeuxSelect(2)}
            shouldItemRender={item =>
              `${item.vaulterFirstName} ${item.vaulterLastName}`
                .toLowerCase()
                .includes(secondVaulter.toLowerCase())
            }
          />

          <Row>
            <Col xs={4}>
              <Input
                type="text"
                onChange={this.onInputChange('entryData.details.secondVaulterFeiId')}
                value={entryData.details.secondVaulterFeiId}
                errors={formErrors}
                name="secondVaulterFeiId"
                label="2nd Vaulter FEI ID"
                buttonAfter={this.renderLoadFeiId('secondVaulterFeiId', 'person')}
                ref="secondVaulterFeiId"
                refInput="secondVaulterFeiId"
              />
            </Col>

            <Col xs={4}>
              <Input
                type="text"
                onChange={this.onInputChange('entryData.details.secondVaulterFirstName')}
                value={entryData.details.secondVaulterFirstName}
                errors={formErrors}
                name="secondVaulterFirstName"
                label="2nd Vaulter First Name"
              />
            </Col>

            <Col xs={4}>
              <Input
                type="text"
                onChange={this.onInputChange('entryData.details.secondVaulterLastName')}
                value={entryData.details.secondVaulterLastName}
                errors={formErrors}
                name="secondVaulterLastName"
                label="2nd Vaulter Last Name"
              />
            </Col>
          </Row>

          <Row>
            <Col xs={4}>
              <Input
                type="select"
                onChange={this.onInputChange('entryData.details.secondVaulterGender')}
                value={entryData.details.secondVaulterGender}
                defaultValue=""
                errors={formErrors}
                name="secondVaulterGender"
                label="2nd Vaulter Gender"
              >
                <option disabled value="" />
                {genders.map(gender => (
                  <option key={gender.value} value={gender.value}>
                    {gender.name}
                  </option>
                ))}
              </Input>
            </Col>

            <Col xs={4}>
              <DatePicker
                onChange={this.onInputChange('entryData.details.secondVaulterDateOfBirth')}
                value={entryData.details.secondVaulterDateOfBirth}
                errors={formErrors}
                name="secondVaulterDateOfBirth"
                label="2nd Vaulter Date of Birth"
              />
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  squadValueChanged = idx => (event, vaulterValue) => {
    let vaultersValues = [...this.state.vaultersValues];
    vaultersValues[idx] = vaulterValue;
    this.setState({ vaultersValues });
  };

  onSquadSelect = idx => vaulterValue => {
    const { vaulters } = this.state;
    const { allVaulters } = this.props;
    const vaulter = allVaulters.filter(
      vaulter => `${vaulter.vaulterFirstName} ${vaulter.vaulterLastName}` === vaulterValue
    )[0];

    vaulters[idx] = {
      vaulterFeiId: vaulter.vaulterFeiId,
      vaulterFirstName: vaulter.vaulterFirstName,
      vaulterLastName: vaulter.vaulterLastName,
      vaulterGender: vaulter.vaulterGender,
      vaulterDateOfBirth: vaulter.vaulterDateOfBirth,
    };

    let vaultersValues = [...this.state.vaultersValues];
    vaultersValues[idx] = vaulterValue;

    this.setState({ vaulters, vaultersValues });
  };

  renderSquadInputs() {
    const { formErrors, vaulters, vaultersValues } = this.state;
    const { allVaulters } = this.props;

    return (
      <div>
        <Input
          type="text"
          onChange={this.onInputChange('entryData.details.squadName')}
          errors={formErrors}
          name="squadName"
          label="Squad Name"
        />

        {vaulters.map((vaulter, idx) => {
          let number = idx + 1;

          if (number === 1) {
            number += 'st';
          } else if (number === 2) {
            number += 'nd';
          } else if (number === 3) {
            number += 'rd';
          } else if (number > 3) {
            number += 'th';
          }

          return (
            <div key={`vaulter_${number}`}>
              <Row>
                <Col xs={10}>
                  <strong style={{ fontSize: 14 }}>{number} Vaulter</strong>
                </Col>
                <Col xs={2}>
                  {vaulters.length > 1 && (
                    <Button
                      type="button"
                      bsStyle="link"
                      bsSize="xs"
                      onClick={this.removeSquadVaulter.bind(this, idx)}
                      style={{ float: 'right', padding: 0 }}
                    >
                      <i className="fa fa-remove fa-fw fa-lg" style={{ color: '#000' }} />
                    </Button>
                  )}
                </Col>
              </Row>

              <div style={{ paddingBottom: 10 }}>
                <AutoComplete
                  label="Choose a vaulter"
                  data={allVaulters}
                  value={vaultersValues[idx]}
                  renderItem={(item, isHighlighted) => (
                    <div key={item._id} style={containerStyle(isHighlighted)}>
                      {`${item.vaulterFirstName} ${item.vaulterLastName}`}
                    </div>
                  )}
                  getItemValue={item => `${item.vaulterFirstName} ${item.vaulterLastName}`}
                  onChange={this.squadValueChanged(idx)}
                  onSelect={this.onSquadSelect(idx)}
                  shouldItemRender={item =>
                    `${item.vaulterFirstName} ${item.vaulterLastName}`
                      .toLowerCase()
                      .includes(vaultersValues[idx].toLowerCase())
                  }
                />

                <Row>
                  <Col xs={4}>
                    <Input
                      type="text"
                      onChange={this.onInputChange(`vaulters.${idx}.vaulterFeiId`)}
                      value={vaulters[idx].vaulterFeiId}
                      errors={formErrors}
                      name={`vaulters[${idx}].vaulterFeiId`}
                      label="Vaulter FEI ID"
                      buttonAfter={this.renderLoadFeiId(`vaulters.${idx}.vaulterFeiId`, 'person')}
                      ref={`vaulters.${idx}.vaulterFeiId`}
                      refInput={`vaulters.${idx}.vaulterFeiId`}
                    />
                  </Col>

                  <Col xs={4}>
                    <Input
                      type="text"
                      onChange={this.onInputChange(`vaulters.${idx}.vaulterFirstName`)}
                      value={vaulters[idx].vaulterFirstName}
                      errors={formErrors}
                      name={`vaulters[${idx}].vaulterFirstName`}
                      label="Vaulter First Name"
                    />
                  </Col>

                  <Col xs={4}>
                    <Input
                      type="text"
                      onChange={this.onInputChange(`vaulters.${idx}.vaulterLastName`)}
                      value={vaulters[idx].vaulterLastName}
                      errors={formErrors}
                      name={`vaulters[${idx}].vaulterLastName`}
                      label="Vaulter Last Name"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={4}>
                    <Input
                      type="select"
                      onChange={this.onInputChange(`vaulters.${idx}.vaulterGender`)}
                      value={vaulters[idx].vaulterGender}
                      defaultValue=""
                      errors={formErrors}
                      name={`vaulters[${idx}].vaulterGender`}
                      label="Vaulter Gender"
                    >
                      <option disabled value="" />
                      {genders.map(gender => (
                        <option key={gender.value} value={gender.value}>
                          {gender.name}
                        </option>
                      ))}
                    </Input>
                  </Col>

                  <Col xs={4}>
                    <DatePicker
                      onChange={this.onInputChange(`vaulters.${idx}.vaulterDateOfBirth`)}
                      value={vaulters[idx].vaulterDateOfBirth}
                      errors={formErrors}
                      name={`vaulters[${idx}].vaulterDateOfBirth`}
                      label="Vaulter Date of Birth"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          );
        })}

        <Button
          type="button"
          bsStyle="primary"
          onClick={this.addSquadVaulter}
          block
          style={{ marginBottom: 10 }}
        >
          <i className="fa fa-plus" /> Add Vaulter
        </Button>
      </div>
    );
  }

  renderCreateEntryModal() {
    const { isPushingData, isAdmin, lungers, horses } = this.props;
    const { showCreateEntryModal, formErrors, entryData, lungerValue, horseValue } = this.state;

    return (
      <Modal show={showCreateEntryModal} onHide={this.closeCreateEntryModal}>
        <Modal.Header closeButton>
          <Modal.Title>Create Entry</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form>
            {false && (
              <Input
                type="select"
                onChange={this.onInputChange('entryData.competition')}
                defaultValue=""
                errors={formErrors}
                name="competition"
                label="Competition"
              >
                <option disabled value="" />
                {competitions.map(competition => (
                  <option key={competition.value} value={competition.value}>
                    {competition.name}
                  </option>
                ))}
              </Input>
            )}

            {isAdmin && (
              <Input
                type="select"
                onChange={this.onInputChange('entryData.nation')}
                defaultValue=""
                value={entryData.nation}
                errors={formErrors}
                name="nation"
                label="Nation"
              >
                <option disabled value="" />
                {nationsWithoutAdmin.map(nation => (
                  <option key={nation.value} value={nation.value}>
                    {nation.name}
                  </option>
                ))}
              </Input>
            )}

            {entryData.competition && (
              <div>
                <Input
                  type="select"
                  onChange={this.onInputChange('entryData.details.category')}
                  defaultValue=""
                  errors={formErrors}
                  name="category"
                  label="Category"
                >
                  <option disabled value="" />
                  {entryData.competition === 'INDIVIDUALS' &&
                    individualCategories.map(category => (
                      <option key={category.value} value={category.value}>
                        {category.name}
                      </option>
                    ))}
                  {entryData.competition === 'PASDEDEUX' &&
                    pasdedeuxCategories.map(category => (
                      <option key={category.value} value={category.value}>
                        {category.name}
                      </option>
                    ))}
                  {entryData.competition === 'SQUAD' &&
                    squadCategories.map(category => (
                      <option key={category.value} value={category.value}>
                        {category.name}
                      </option>
                    ))}
                </Input>

                {entryData.competition === 'INDIVIDUALS' && this.renderIndividualsInputs()}

                {entryData.competition === 'PASDEDEUX' && this.renderPasDeDeuxInputs()}

                {entryData.competition === 'SQUAD' && this.renderSquadInputs()}
                <div style={{ paddingBottom: 20 }}>
                  <AutoComplete
                    label="Choose a horse"
                    data={horses}
                    value={horseValue}
                    renderItem={(item, isHighlighted) => (
                      <div key={item._id} style={containerStyle(isHighlighted)}>
                        {item.horseName}
                      </div>
                    )}
                    getItemValue={item => item.horseName}
                    onChange={(event, horseValue) => this.setState({ horseValue })}
                    onSelect={this.onHorseSelect}
                    shouldItemRender={item =>
                      item.horseName.toLowerCase().includes(horseValue.toLowerCase())
                    }
                  />

                  <Row>
                    <Col xs={6}>
                      <Input
                        type="text"
                        onChange={this.onInputChange('entryData.details.horseFeiId')}
                        value={entryData.details.horseFeiId}
                        errors={formErrors}
                        name="horseFeiId"
                        label="Horse FEI ID"
                        buttonAfter={this.renderLoadFeiId('horseFeiId', 'horse')}
                        ref="horseFeiId"
                        refInput="horseFeiId"
                      />
                    </Col>

                    <Col xs={6}>
                      <Input
                        type="text"
                        onChange={this.onInputChange('entryData.details.horseName')}
                        value={entryData.details.horseName}
                        errors={formErrors}
                        name="horseName"
                        label="Horse Name"
                      />
                    </Col>
                  </Row>
                </div>
                <div style={{ paddingBottom: 20 }}>
                  <AutoComplete
                    label="Choose a lunger"
                    data={lungers}
                    value={lungerValue}
                    renderItem={(item, isHighlighted) => (
                      <div key={item._id} style={containerStyle(isHighlighted)}>
                        {`${item.lungerFirstName} ${item.lungerLastName}`}
                      </div>
                    )}
                    getItemValue={item => `${item.lungerFirstName} ${item.lungerLastName}`}
                    onChange={(event, lungerValue) => this.setState({ lungerValue })}
                    onSelect={this.onLungerSelect}
                    shouldItemRender={item =>
                      `${item.lungerFirstName} ${item.lungerLastName}`
                        .toLowerCase()
                        .includes(lungerValue.toLowerCase())
                    }
                  />

                  <Row>
                    <Col xs={4}>
                      <Input
                        type="text"
                        onChange={this.onInputChange('entryData.details.lungerFeiId')}
                        value={entryData.details.lungerFeiId}
                        errors={formErrors}
                        name="lungerFeiId"
                        label="Lunger FEI ID"
                        buttonAfter={this.renderLoadFeiId('lungerFeiId', 'person')}
                        ref="lungerFeiId"
                        refInput="lungerFeiId"
                      />
                    </Col>

                    <Col xs={4}>
                      <Input
                        type="text"
                        onChange={this.onInputChange('entryData.details.lungerFirstName')}
                        value={entryData.details.lungerFirstName}
                        errors={formErrors}
                        name="lungerFirstName"
                        label="Lunger First Name"
                      />
                    </Col>

                    <Col xs={4}>
                      <Input
                        type="text"
                        onChange={this.onInputChange('entryData.details.lungerLastName')}
                        value={entryData.details.lungerLastName}
                        errors={formErrors}
                        name="lungerLastName"
                        label="Lunger Last Name"
                      />
                    </Col>
                  </Row>
                </div>

                <Input
                  type="textarea"
                  onChange={this.onInputChange('entryData.details.notes')}
                  errors={formErrors}
                  name="notes"
                  label="Notes"
                />
              </div>
            )}
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="submit"
            onClick={this.handleSubmitForm}
            disabled={isPushingData}
            bsStyle="primary"
          >
            Submit
          </Button>
          <Button type="button" onClick={this.closeCreateEntryModal} disabled={isPushingData}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const { isAdmin } = this.props;

    if (process.env.REACT_APP_DISABLED_ENTRIES === 'true' && !isAdmin) {
      return <div />;
    }

    return (
      <div>
        {this.renderCreateEntryModal()}

        <Button
          type="button"
          bsStyle="primary"
          bsSize="sm"
          onClick={this.openCreateEntryModal}
          block
          style={{ marginTop: isAdmin ? undefined : 5 }}
        >
          <i className="fa fa-plus" /> Create Entry
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/entry/CreateEntry.js